import ReleaseLeadPage  from "./ReleaseLeadPage";
let idStr = "0";
let url = location.hash; //获取url中"?"符后的字串
if (url.indexOf("?") != -1) {
  //判断是否有参数
  let str = url.substr(1); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
  let strs = str.split("="); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
  idStr = strs[1]; //直接弹出第一个参数 （如果有多个参数 还要进行循环的）
}
let id = 0;
let name = "";
if (idStr != null) {
  let data = JSON.parse(decodeURIComponent(idStr));
  id = data.id;
  name = data.leadName;
}
console.log("传递参数", id, name);
export default function NewWindowReleaseLeadPage() {
  //第一种方法
  return (
    <ReleaseLeadPage leadId={id}  />
  );
}
